import { render, staticRenderFns } from "./MobileMenuItem.vue?vue&type=template&id=1c61cbe0&scoped=true&"
import script from "./MobileMenuItem.vue?vue&type=script&lang=js&"
export * from "./MobileMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./MobileMenuItem.vue?vue&type=style&index=0&id=1c61cbe0&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c61cbe0",
  null
  
)

export default component.exports